export default __webpack_public_path__ + "static/media/CFO.5e97d4ec.jpeg";